import { createContext, useEffect, useState } from 'react';
import { authManager } from 'src/modules/authMobile/auth-manager';
import Loading from 'src/components/Loading';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { authManagerWeb } from 'src/modules/authMobile/auth-manager-web';
import { isPWA } from 'src/utils/mobile';

// type AuthContextProps = {
//   accessToken: string | null;
// };

// export const AuthContext = createContext<AuthContextProps>({
//   accessToken: null,
// });

// export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [token, setToken] = useState<string | null>(null);

//   // useEffect(() => {
//   //   authManager.init((accessToken) => {
//   //     setToken(accessToken);
//   //   });
//   // }, []);

//   useEffect(() => {
//     authManager.init((accessToken) => {
//       setToken(accessToken);
//     });

//     // fallback (на случай если токен уже есть)
//     setTimeout(async () => {
//       const { value } = await SecureStoragePlugin.get({ key: 'accessToken' });

//       if (value) {
//         setToken(value);
//       }
//     }, 1500);

//   }, []);

//   if (!token) {
//     return (
//       <div className='grid place-items-center min-h-[100vh]'>
//         <Loading />
//       </div>
//     );
//   }

//   return (
//     <AuthContext.Provider value={{ accessToken: token }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };


type AuthContextProps = {
  isAuthenticated: boolean;
  loading: boolean;
  accessToken: string | null;
}

export const AuthContext = createContext<AuthContextProps>({
  isAuthenticated: false,
  loading: true,
  accessToken: null,
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffect(() => {
    if (isPWA()) {
      authManagerWeb.init(() => {
        setIsAuthenticated(true);
        setLoading(false);
      });
    } else {
      authManager.init((accessToken) => {
        setAccessToken(accessToken);
        setIsAuthenticated(true);
        setLoading(false);
      });

      // fallback (на случай если токен уже есть)
      setTimeout(async () => {
        const { value } = await SecureStoragePlugin.get({ key: 'accessToken' });

        if (value) {
          setAccessToken(value);
        }
      }, 1500);
    }

  }, []);

  if (loading) {
    return (
      <div className='grid place-items-center min-h-[100vh]'>
        <Loading />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, accessToken }}>
      {children}
    </AuthContext.Provider>
  );
};
